var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"indicator",style:({ background: _vm.background })},[_c('x-icon',{attrs:{"type":"mdi","size":"22","path":_vm.mdi[_vm.status],"color":_vm.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }